import React from "react"
import { cn } from "../../styles/utils"
import { Box } from "../Box"
import { Text } from "../Text"

type FormProps = {
  children: React.ReactNode
  onSubmit: (e: React.FormEvent) => void
  className?: string
  error?: string
}

export const Form: React.FC<FormProps> = ({ children, className, error }) => {
  return (
    <Box className={cn("space-y-4", className)}>
      {children}
      {error && <Text className="text-error-500 text-sm mt-2">{error}</Text>}
    </Box>
  )
}
